import React, { Component } from 'react';
import { Modal, message, Spin, Input, Radio } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const RadioGroup = Radio.Group;

class Config extends Component {
    state = {
        params: {},
        record: {},
        isConfig: true,
        visible: false,
        loading: false,
    }

    show = (record, type) => {
        const { contractBackActualPaymentTermId, contractBackRecordId, actualPaymentTerms,  comment, actualPaymentStatus  } = record;
        this.setState({
            params: {
                contractBackActualPaymentTermId, contractBackRecordId, actualPaymentTerms,  comment, status: actualPaymentStatus,
            },
            record,
            isConfig: type == 'config',
        }, () => {
            this.setState({ visible: true });
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params: { actualPaymentTerms, status, comment }, params, isConfig } = this.state;
        if(isConfig) {
            if (!actualPaymentTerms) {
                message.warning('请输入合同约定账期');
                return;
            }
        }else {
            if (status == 'PENDING_APPROVAL' || !status ) {
                message.warning('请选择审核结论');
                return;
            }
            if (!comment && status == 'DISAGREE_APPROVAL') {
                message.warning('审核不通过原因');
                return;
            }
        }
        
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: isConfig ? API_URL.contract.updateContractBackActualPaymentTerm : API_URL.contract.approvalContractBackActualPaymentTerm,
            data: {
                ...params
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    render() {
        const { visible, loading, params: { actualPaymentTerms, comment, status }, record:{ remark, paymentTerms }, isConfig } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={`${isConfig ? '配置' : '审核'}合同约定账期`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal EditPersonModal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="420px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            <li className="modal-item">
                                <div className="item-left">发票号:</div>
                                <div className="item-right">
                                    {remark}
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">账期:</div>
                                <div className="item-right">
                                    {paymentTerms}
                                </div>
                            </li>
                            <li className="modal-item">
                                <div className="item-left">{ isConfig ? asterisk : ''}合同约定账期:</div>
                                <div className="item-right">
                                    {
                                        isConfig ? 
                                        <Input 
                                            style={{ width: 120 }} 
                                            value={actualPaymentTerms} 
                                            placeholder={'请输入'} 
                                            onChange={e => this.handleChange(e.target.value, 'actualPaymentTerms')}
                                        /> :
                                        actualPaymentTerms
                                    }
                                </div>
                            </li>
                            {
                                !isConfig &&
                                <li className="modal-item">
                                    <div className="item-left">{asterisk}审核结论:</div>
                                    <div className="item-right">
                                    <RadioGroup onChange={e => this.handleChange(e.target.value, 'status')} value={status}>
                                        <Radio value={'AGREE_APPROVAL'}>审核通过</Radio>
                                        <Radio value={'DISAGREE_APPROVAL'}>审核不通过</Radio>
                                    </RadioGroup>
                                    </div>
                                </li>
                            }
                            {
                                !isConfig && status == 'DISAGREE_APPROVAL' &&
                                <li className="modal-item">
                                    <div className="item-left"></div>
                                    <div className="item-right">
                                        <Input 
                                            style={{ width: 120 }} 
                                            value={comment} 
                                            placeholder={'审核不通过原因'} 
                                            onChange={e => this.handleChange(e.target.value, 'comment')}
                                        /> 
                                    </div>
                                </li>
                            }
                        </ul>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default Config;


// WEBPACK FOOTER //
// ./src/components/contractManagement/returnedMoney/Config.js